var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductPlan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 59,
    viewBox: "0 0 69 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_9259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.68 58.11H4.35C1.95 58.11 0 56.16 0 53.76V9.45001C0 7.05001 1.95 5.10001 4.35 5.10001H63.67C66.07 5.10001 68.02 7.05001 68.02 9.45001V53.76C68.02 56.16 66.07 58.11 63.67 58.11H63.68Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.68 5.09H4.35C1.95 5.09 0 7.04 0 9.45V16.06H68.03V9.45C68.03 7.05 66.08 5.1 63.68 5.1V5.09Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.26 9.86C14.43 9.86 13.76 9.19 13.76 8.36V1.5C13.76 0.67 14.43 0 15.26 0C16.09 0 16.76 0.67 16.76 1.5V8.36C16.76 9.19 16.09 9.86 15.26 9.86Z",
    fill: "#36414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.02 9.86C33.19 9.86 32.52 9.19 32.52 8.36V1.5C32.52 0.67 33.19 0 34.02 0C34.85 0 35.52 0.67 35.52 1.5V8.36C35.52 9.19 34.85 9.86 34.02 9.86Z",
    fill: "#36414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.77 9.86C51.94 9.86 51.27 9.19 51.27 8.36V1.5C51.27 0.67 51.94 0 52.77 0C53.6 0 54.27 0.67 54.27 1.5V8.36C54.27 9.19 53.6 9.86 52.77 9.86Z",
    fill: "#36414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2506 50.6299H30.7806C29.1806 50.6299 27.8906 49.3399 27.8906 47.7399V41.2699C27.8906 39.6699 29.1806 38.3799 30.7806 38.3799H37.2506C38.8506 38.3799 40.1406 39.6699 40.1406 41.2699V47.7399C40.1406 49.3399 38.8506 50.6299 37.2506 50.6299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5006 50.6299H12.0306C10.4306 50.6299 9.14062 49.3399 9.14062 47.7399V41.2699C9.14062 39.6699 10.4306 38.3799 12.0306 38.3799H18.5006C20.1006 38.3799 21.3906 39.6699 21.3906 41.2699V47.7399C21.3906 49.3399 20.1006 50.6299 18.5006 50.6299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0106 50.6299H49.5406C47.9406 50.6299 46.6506 49.3399 46.6506 47.7399V41.2699C46.6506 39.6699 47.9406 38.3799 49.5406 38.3799H56.0106C57.6106 38.3799 58.9006 39.6699 58.9006 41.2699V47.7399C58.9006 49.3399 57.6106 50.6299 56.0106 50.6299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2506 34.95H30.7806C29.1806 34.95 27.8906 33.66 27.8906 32.06V25.59C27.8906 23.99 29.1806 22.7 30.7806 22.7H37.2506C38.8506 22.7 40.1406 23.99 40.1406 25.59V32.06C40.1406 33.66 38.8506 34.95 37.2506 34.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5006 34.95H12.0306C10.4306 34.95 9.14062 33.66 9.14062 32.06V25.59C9.14062 23.99 10.4306 22.7 12.0306 22.7H18.5006C20.1006 22.7 21.3906 23.99 21.3906 25.59V32.06C21.3906 33.66 20.1006 34.95 18.5006 34.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0106 34.95H49.5406C47.9406 34.95 46.6506 33.66 46.6506 32.06V25.59C46.6506 23.99 47.9406 22.7 49.5406 22.7H56.0106C57.6106 22.7 58.9006 23.99 58.9006 25.59V32.06C58.9006 33.66 57.6106 34.95 56.0106 34.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9795 47.0799L31.0695 46.3599C30.6195 46.0099 30.5495 45.3599 30.8995 44.9099C31.2495 44.4599 31.8995 44.3899 32.3495 44.7399L32.6795 44.9999C32.7895 45.0899 32.9495 45.0699 33.0395 44.9599L35.5095 41.9599C35.8695 41.5199 36.5195 41.4599 36.9595 41.8199C37.3995 42.1799 37.4595 42.8299 37.0995 43.2699L34.1595 46.8399C33.6095 47.4999 32.6395 47.6099 31.9695 47.0799H31.9795Z",
    fill: "#019EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8291 47.0799L49.9191 46.3599C49.4691 46.0099 49.3991 45.3599 49.7491 44.9099C50.0991 44.4599 50.7491 44.3899 51.1991 44.7399L51.5291 44.9999C51.6391 45.0899 51.7991 45.0699 51.8891 44.9599L54.3591 41.9599C54.7191 41.5199 55.3691 41.4599 55.8091 41.8199C56.2491 42.1799 56.3091 42.8299 55.9491 43.2699L53.0091 46.8399C52.4591 47.4999 51.4891 47.6099 50.8191 47.0799H50.8291Z",
    fill: "#019EF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_9259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.03,
    height: 58.11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPlan);
export default __webpack_public_path__ + "static/media/productPlan.53a5f813ef06b8a84f28b7b883e68598.svg";
export { ForwardRef as ReactComponent };